export class Shape2DClass {
}
//# sourceMappingURL=Shape2DClass.js.map